var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderShared(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.973 12.65C15.4744 12.65 15.9042 12.4715 16.2625 12.1145C16.6209 11.7575 16.8 11.3283 16.8 10.827C16.8 10.3257 16.6215 9.89583 16.2645 9.5375C15.9075 9.17917 15.4783 9 14.977 9C14.4757 9 14.0459 9.1785 13.6875 9.5355C13.3292 9.89252 13.15 10.3217 13.15 10.823C13.15 11.3243 13.3285 11.7542 13.6855 12.1125C14.0425 12.4708 14.4717 12.65 14.973 12.65ZM10.975 17H18.975V16.525C18.975 15.825 18.6209 15.2833 17.9125 14.9C17.2042 14.5167 16.225 14.325 14.975 14.325C13.725 14.325 12.7459 14.5167 12.0375 14.9C11.3292 15.2833 10.975 15.825 10.975 16.525V17ZM3.52502 20C3.12502 20 2.77502 19.8458 2.47502 19.5375C2.17502 19.2292 2.02502 18.8833 2.02502 18.5V5.5C2.02502 5.11667 2.17502 4.77083 2.47502 4.4625C2.77502 4.15417 3.12502 4 3.52502 4H10.525L12.025 5.5H20.525C20.9084 5.5 21.2542 5.65417 21.5625 5.9625C21.8709 6.27083 22.025 6.61667 22.025 7V18.5C22.025 18.8833 21.8709 19.2292 21.5625 19.5375C21.2542 19.8458 20.9084 20 20.525 20H3.52502ZM3.52502 5.5V18.5H20.525V7H11.4L9.90002 5.5H3.52502Z",
    fill: "#132353"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderShared);
export default __webpack_public_path__ + "static/media/folderShared.2f0a04918d3141946f205097c6fd43d7.svg";
export { ForwardRef as ReactComponent };